// MyChecklists.js
import React, { useCallback, useEffect, useState, useRef } from 'react';
import useFetch from '../../hooks/useFetch';
import { Link, useLocation } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import "../../styles/MyProfile.css";
import Tooltip from '../../components/utils/Tooltip';

const MyChecklists = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();

  const navigate = useNavigate();
  const userId = authState.user._id;
  const [createdChecklists, setCreatedChecklists] = useState([]);
  const [hasCretaedChecklistStatus, setHasCretaedChecklistStatus] = useState(false);
  const [hasCretaedChecklistStatusMsg, setHasCretaedChecklistStatusMsg] = useState('');
  const [selectedChecklistId, setSelectedChecklistId] = useState([]);
  const [selectedViewItemChecklistId, setSelectedViewItemChecklistId] = useState(false);
  const [selectedAddItemChecklistId, setSelectedAddItemChecklistId] = useState(false);
  const [checklists, setChecklists] = useState([]);

  const [hasNewItemCodeClicked, setHasNewItemCodeClicked] = useState(false);
  // const [newItemCode, setNewItemCode] = useState('');

  const [newItemCodeStatus, setNewItemCodeStatus] = useState(false);
  const [newItemCodeStatusMsg, setNewItemCodeStatusMsg] = useState('');
  const [newItemCode, setNewItemCode] = useState('');
  const [newItemId, setNewItemId] = useState('');
  const [newItemName, setNewItemName] = useState('');
  const [newItemEmail, setNewItemEmail] = useState('');
  const [newItemCodeMsg, setNewItemCodeMsg] = useState('');
  const [verifyNewItemCodeButtonClicked, setVerifyNewItemCodeButtonClicked] = useState(false);
  const [error, setError] = useState('');
  const [addNewButtonClickedStatus, setAddNewButtonClickedStatus] = useState(false);
  const [addNewItemRecordStatus, setAddNewItemRecordStatus] = useState(false);
  const [addNewItemRecordStatusMsg, setAddNewItemRecordStatusMsg] = useState('');
  
  useEffect(() => {
    fetchMyChecklistList(); // Fetch checklists created by the logged-in user on component mount
  }, []);

  const fetchMyChecklistList = useCallback(() => {
    // console.log("fetchMyChecklistList for API call ", userId);
    const config = {
        url: "/mychecklist/mycreatedlist",
        method: "post",
        headers: { Authorization: authState.token },
        data: { createdBy: userId }
    };
  
    fetchData(config)
        .then(response => {
          // console.log("API Response: ", response); 
            if (response && response.status) {
                // console.log("checklist list found ", response);
                setHasCretaedChecklistStatus(true);
                setCreatedChecklists(response.checklists);
                setHasCretaedChecklistStatusMsg("Checklists found. 😊");
            } else {
                // console.log("Checklists Code Not found");
                setHasCretaedChecklistStatusMsg(`Checklists not found! 😔`);
            }
        })
        .catch(error => {
            // console.log("Checklists Not found!", error);
            setHasCretaedChecklistStatusMsg("Error in getting data");
        });
  }, [fetchData, authState.token]);
  
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
  }, [authState.isLoggedIn, fetchMyChecklistList]);

// // here
// const newItemCodeValidationClicked = (newItemCode) => {
//   if (/^TU[a-zA-Z0-9]{12}$/.test(newItemCode)) {
//       fetchNewItemCode(newItemCode);
//   } else {
//       setError('Please enter a valid 14-character Think5Whys User Code starting with TU');
//   }
// };

// const handleNewItemCodeValidation = () => {
//   setVerifyNewItemCodeButtonClicked(true);
// };

// const fetchNewItemCode = useCallback((newItemCode) => {
//   console.log("newItemCode for API call ", newItemCode);
//   const config = {
//       url: "/auth/verifyt5wcode",
//       method: "post",
//       headers: { Authorization: authState.token },
//       data: { think5whyscode: newItemCode }
//   };

//   fetchData(config)
//       .then(response => {
//           if (response && response.status) {
//               console.log("newItemCode found ", response);
//               setNewItemCodeStatus(true);
//               setNewItemId(response.t5wcode._id);
//               setNewItemName(response.t5wcode.name);
//               setNewItemCodeStatusMsg(`User Code ${newItemCode} found. 😊`);
//           } else {
//               console.log("User Not found");
//               setNewItemCodeStatus(false);
//               setNewItemCodeStatusMsg(`User Code ${newItemCode} not found! 😔 Make sure the User Code is valid.`);
//           }
//       })
//       .catch(error => {
//           console.log("newItemCode Not found!");
//           setNewItemCodeStatus(false);
//           setNewItemCodeStatusMsg(`User Code ${newItemCode} not found! 😔 Make sure the User Code is valid.`);
//       });
// }, [authState.token, fetchData, setNewItemCodeStatus,setNewItemId,setNewItemName,setNewItemName]);


// const handleDelete = (id) => {
//   const config = {
//     url: `/mychecklist/${id}`,
//     method: "delete",
//     headers: { Authorization: authState.token }
//   };
//   fetchData(config).then(() => fetchTasks(purpose));
// }

const fetchChecklist = useCallback(() => {
  const config = {
      url: "/mychecklist/mycreatedlist",
      method: "post",
      headers: { Authorization: authState.token },
      data: { userId: authState.user._id}
    };
  // console.log("My fetchChecklist Search Payload: ", config);

  fetchData(config, { showSuccessToast: false }).then(data => setChecklists(data.checklist));
}, [authState.token, fetchData, authState.user._id]);

useEffect(() => {
  if (!authState.isLoggedIn) return;
  fetchChecklist();
}, [authState.isLoggedIn, fetchChecklist]);

const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  
  const deleteClicked = () => {
    setIsDeleteClicked(true);
  }
  
  const noDeleteClicked = () => {
    setIsDeleteClicked(false);
  }

const handleChecklistDelete = (id) => {
  const config = {
    url: `/mychecklist/${id}`,
    method: "delete",
    headers: { Authorization: authState.token }
  };

  fetchData(config).then(() => fetchChecklist());
  setIsDeleteClicked(false);
}

const addNewButtonClicked = (checklistid, checklistCode, checklistTitle, checklistType, newItemId, newItemCode, newItemName) => {
    setAddNewButtonClickedStatus(true);
    addNewItemRecord(checklistid, checklistCode, checklistTitle, checklistType, newItemId, newItemCode, newItemName);
};

const addNewItemRecord = useCallback((checklistid, checklistCode, checklistTitle, checklistType, newItemId, newItemCode, newItemName) => {
  // console.log("fetchAddNewItemRecord for API call ", checklistid, checklistCode, checklistTitle, checklistType, newItemId, newItemCode, newItemName);
  const newItemData = {
    checklistId: checklistid, 
    checklistCode: checklistCode, 
    checklistTitle: checklistTitle,
    checklistType: checklistType,
    creatorCode: authState.user.think5whyscode,
    creatorName: authState.user.name,
    dateCreated: new Date(),
    itemId: newItemId,
    itemCode: newItemCode,
    itemName: newItemName,
    remarks: "New Item "+newItemName+" Joined in the Checklist "+checklistTitle,
    createdBy: authState.user._id,
    isActive: 1,
    isDeleted: 0
  };

  const config = {
      url: "/mychecklist/addnewitem",
      method: "post",
      headers: { Authorization: authState.token },
      data: { newItemData }
  };
  // console.log("fetchAddNewItemRecord for config call ", config);

  fetchData(config)
      .then(response => {
          if (response && response.status) {
              // console.log("newItemCode added ", response);
              setAddNewItemRecordStatus(true);
              setAddNewItemRecordStatusMsg(`Checklist Item ${newItemName} Added. 😊`);
          } else {
              // console.log("User Not added");
              setAddNewItemRecordStatusMsg(`Checklist Item ${newItemName} not added! 😔 Please retry.`);
          }
      })
      .catch(error => {
          // console.log("newItemCode Not added!");
          setAddNewItemRecordStatusMsg(`Checklist Item ${newItemName} not added! 😔 Please retry.`);
      });
}, [fetchData, setAddNewItemRecordStatus]);


useEffect(() => {
  if (!authState.isLoggedIn) return;
}, [authState.isLoggedIn, addNewItemRecord]);

//

  const handleCreateChecklistClick = () => {
    navigate("/checklist/add");
  };

  const handleChecklistView = (_id) => {
    setSelectedChecklistId(prevId => (prevId === _id ? null : _id));
  };

  const handleAddItems = (_id) => {
    setSelectedAddItemChecklistId(prevId => (prevId === _id ? null : _id));
  };

  const handleViewItems = (_id) => {
    setSelectedViewItemChecklistId(prevId => (prevId === _id ? null : _id));
  };

  const formatDateTime = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Profile - My Think5Whys Checklist</h2>
      </div>
      <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full text-white'>
        <div className="flex justify-between mt-4 items-center border-b border-b-gray-300">
          <h3 className='text-lg mt-1 mx-2 text-white'>My Master Checklist</h3>
          <button
            className='bg-purple-700'
            onClick={() => handleCreateChecklistClick()}
            style={{ maxWidth: '150px' }}
          >
            Create New
          </button>
        </div>
        <div className="mt-4">
          {createdChecklists.length === 0 ? (
            <div className='flex justify-center'>
              <p className='text-orange-600'>You Have Not Created A Checklist Yet</p>
            </div>
          ) : (
            createdChecklists.map((checklist, index) => (
              <div key={checklist._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                <div className='flex'>
                  <span className='font-medium text-black'>
                    {index + 1}. {checklist.checklistTitle}
                  </span>
                  <Tooltip text={"View details"} position={"top"}>
                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleChecklistView(checklist._id)}>
                      <i className="fa-solid fa-eye"></i>
                    </span>
                  </Tooltip>
                  <Tooltip text={"Edit this record"} position={"top"}>
                    <Link to={`/checklist/${checklist._id}`} className='mr-4 text-green-600 cursor-pointer'>
                      <i className="fa-solid fa-pen"></i>
                    </Link>
                  </Tooltip>
                  <Tooltip text={"Delete this record"} position={"top"}>
                    <span className='text-red-500 cursor-pointer mr-2' onClick={() => deleteClicked()}>
                      <i className="fa-solid fa-trash"></i>
                    </span>
                  </Tooltip>
                  { isDeleteClicked && (
                    <div>
                      <div
                        className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
                        style={{ zIndex: 1000 }}
                      >
                        <div className="w-6/12 flex flex-row justify-center bg-blue-200 text-black border-b border-b-gray-300 mr-4 ml-4 p-4">
                            <button
                              className="bg-red-700 w-40"
                              onClick={() =>  handleChecklistDelete(checklist._id)}
                              style={{ maxWidth: "150px" }}
                            >
                              Confirm To Delete
                            </button>
                            <button
                              className="bg-yellow-300 ml-4 text-black w-40"
                              onClick={() =>  noDeleteClicked() }
                              style={{ maxWidth: "150px" }}
                            >
                              No I Do Not Want To Delete
                            </button>
                        </div>
                      </div>
                    </div>
                  )}
                  <Tooltip text={"Add Checklist Item"} position={"top"}>
                    <span className='ml-2 text-blue-500 cursor-pointer' onClick={() => handleAddItems(checklist._id)}>
                      <i className="fa-solid fa-list-check"></i>
                    </span>
                  </Tooltip>
                  <Tooltip text={"View Checklist Item List"} position={"top"}>
                    <span className='ml-2 text-blue-500 cursor-pointer' onClick={() => handleViewItems(checklist._id)}>
                      <i className="fa-solid fa-square-check"></i>
                    </span>
                  </Tooltip>
                </div>
                {selectedChecklistId === checklist._id && (
                  <div className='bg-gray-200 text-black'>
                    <p><strong>Checklist Type:</strong> {checklist.checklistType}</p>
                    <p><strong>Created Date:</strong> {formatDateTime(checklist.dateCreated)}</p>
                    <p><strong>Description:</strong>{checklist.checklistDesc}</p>
                    <p><strong>Do's:</strong>{checklist.dos}</p>
                    <p><strong>Don't:</strong> {checklist.dont}</p>
                  </div>
                )}
                {selectedViewItemChecklistId === checklist._id && (
                  <div>
                    {checklist.myChecklistItems.length > 0 ? (
                      checklist.myChecklistItems.map((checklistitem, index) => (
                        <div key={index} className='bg-gray-200 text-black border-b border-b-yellow-300 mb-1'>
                          <p><strong>SN:</strong> {index+1}</p>
                          <p><strong>Item Name:</strong><span className="text-blue-500"> {checklistitem.name}</span></p>
                          <p><strong>Created Date:</strong> {formatDateTime(checklistitem.dateJoined)}</p>
                          <p><strong>Status:</strong> {checklistitem.isActive ? "Active" : "Left"}</p>
                        </div>
                      ))
                    ) : (
                      <div className='bg-gray-200 text-black'>
                        <p>No Other Item Found</p>
                      </div>
                    )}
                  </div>
                )}
                {/* {selectedAddItemChecklistId === checklist._id && (
                  <div>
                    <div className='mb-4 flex text-wrap justify-center'>
                      <p className='text-white'>Input a 14 Characters Alphanumeric Think5Whys User Code Starting with TU:</p>
                    </div>
                    <div className="mb-4 flex justify-center">
                      <input
                        type="text"
                        name="newItemCode"
                        id="newItemCode"
                        value={newItemCode}
                        placeholder="Input Referrer ID"
                        onChange={(e) => setNewItemCode(e.target.value)}
                        className="h-12 text-center p-2 border border-gray-300"
                      />
                    </div>
                    <div className="mb-4 flex justify-center">
                      {error && <p className="text-red-800 justify-left">{error}</p>}
                    </div>
                    <div className='mb-4 flex flex-col items-center'>
                      <p className={newItemCodeStatus ? "text-green-800 text-lg" : "text-red-600 text-lg"}>
                        {newItemCodeStatusMsg}
                      </p>
                      <button
                        type="button"
                        className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                        onClick={() => {
                          newItemCodeValidationClicked(newItemCode);
                          handleNewItemCodeValidation();
                        }}
                        disabled={newItemCodeStatus}
                      >
                        {newItemCodeStatus ? "User ID Validated" : "Validate User ID"}
                      </button>
                    </div>
                    {newItemCodeStatus && (
                      <div className="mb-2">
                        <div className="mb-4 text-lg text-white">
                          <div>
                            <div className='flex justify-center'>
                              <p className='text-xl text-green-500'>
                                User Code {newItemCode} Validated for Checklist: 
                                <span>{checklist.checklistTitle}</span>
                              </p>
                            </div>
                            <div className='flex justify-center'>  
                              <button
                                type="button"
                                className="block w-full md:w-auto bg-green-800 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                onClick={() => {
                                  addNewButtonClicked(checklist._id, checklist.checklistCode, checklist.checklistTitle, checklistTypeNames[checklist.checklistType], newItemId, newItemCode, newItemName );
                                }}
                                disabled={addNewItemRecordStatus}
                              >
                                Add {newItemName} To Checklist {checklist.checklistName}
                              </button>
                            </div>
                          </div>
                          <div className='flex justify-center'>
                              {addNewItemRecordStatus ? (
                                <p className='text-xl text-green-500'>Item {newItemName} Added To Your Checklist {checklist.checklistTitle}</p>
                                )  : (
                                  <p className='text-xl text-red-500'>Problem in adding Item {newItemName} To Your Checklist {checklist.checklistTitle}</p>
                              )}
                            </div>
                        </div>
                      </div>
                    )}
                  </div>
                )} */}
              </div>
            ))
          )}
        </div>
      </div>
    </MainLayout>
  );  
};

export default MyChecklists;


